import { render, staticRenderFns } from "./change-language.vue?vue&type=template&id=56da1b23&scoped=true&"
import script from "./change-language.vue?vue&type=script&lang=js&"
export * from "./change-language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da1b23",
  null
  
)

export default component.exports